//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "UsersList",
    components: {},
    props: {
        users: {
            type: Array,
            default() {
                return [];
            }
        },
        primaryLine: {
            type: Number,
            default: 0
        },
        secondaryLine: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {};
    },
    methods: {
        setPrimary(index) {
            this.$emit("primaryClick", index);
        },
        toggleSecondary(index) {
            this.$emit("secondaryClick", index);
        }
    }
};
